import React from 'react';
import MaskedInput from 'react-maskedinput';
import moment from 'moment';

import DatePicker from '../../../_ui/DatePicker';
import styles from './PlainDateInput.scss';

// const propTypes = {
//   id: React.PropTypes.string,
//   label: React.PropTypes.string,
//   style: React.PropTypes.object,
//   value: React.PropTypes.string,
//   mask: React.PropTypes.string,
//   placeholder: React.PropTypes.string,
//   format: React.PropTypes.string,
//   disabledDaysInPicker: React.PropTypes.func,
//   onChangeDate: React.PropTypes.func,
// };

const defaultProps = {
  label: '',
  value: '',
  mask: '11.11.1111',
  placeholder: '__.__.____',
  format: 'DD.MM.YYYY',
};

export default class PlainDateInput extends React.Component {

  handleDayPick = (day) => {
    const { onChangeDate, format } = this.props;
    if (typeof onChangeDate === 'function') {
      onChangeDate(moment(day).format(format));
    }
  }

  handleChange = (e) => {
    const { onChangeDate } = this.props;
    if (typeof onChangeDate === 'function') {
      onChangeDate(e.target.value);
    }
  }


  render() {
    const {
      id,
      label,
      style,
      value,
      format,
      mask,
      placeholder,
      disabledDaysInPicker,
      onChangeDate, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;
    const date = moment(value, format, true);
    const isDateValid = date.isValid();

    return (
      <div style={style} className={styles.root}>
        { label && <label htmlFor={id} className={styles.label} >{label}</label> }
        <MaskedInput
          mask={mask}
          placeholder={placeholder}
          className={styles.input}
          name={id}
          id={id}
          value={value}
          onChange={this.handleChange}
          {...other}
        />
        <DatePicker
          day={isDateValid ? date.toDate() : new Date(Date.now() + 86400000)}
          className={styles.datePicker}
          onChangeDay={this.handleDayPick}
          disabledDays={disabledDaysInPicker}
          popupTop
        />

      </div>
    );
  }
}

// PlainDateInput.propTypes = propTypes;
PlainDateInput.defaultProps = defaultProps;
